export const deleteApiKey = `
  mutation DeleteApiKey($input: DeleteApiKeyInput!) {
    deleteApiKey(input: $input) {
      id
    }
  }
`;
